<p-toast></p-toast>

<!-- Show loading while checking LPR status -->
<div *ngIf="isCheckingLPRStatus" class="flex align-items-center justify-content-center p-5">
    <p-progressSpinner></p-progressSpinner>
</div>

<!-- Show message if LPR is not active -->
<div *ngIf="!isCheckingLPRStatus && !isLPRActive" class="surface-section px-4 py-5 md:px-6 lg:px-8 text-center">
    <div class="mb-3">
        <i class="pi pi-info-circle text-6xl text-orange-500"></i>
    </div>
    <div class="text-900 text-2xl font-bold mb-3">LPR Billing is not active on the portal</div>
    <div class="text-700 text-lg mb-5">
        Please use the old attendant portal to update monthly invoices for this location.
    </div>
    <a [href]="siteUrl" class="p-button p-component">
        <span class="p-button-label">Go to Old Portal</span>
    </a>
</div>

<!-- Show normal content only if LPR is active -->
<div *ngIf="!isCheckingLPRStatus && isLPRActive">
<div class="flex align-items-center justify-content-between mb-3">
    <div>
        <h3 class="m-0">Location {{ locationId }} Monthly Invoices</h3>
        <span class="text-color-secondary">
            {{ monthlyInvoicesPendingCount }} invoice(s) pending to be generated
        </span>
    </div>
    <div class="flex align-items-center gap-2">
        <!-- Process Selected Invoices Button -->
        <p-button
            *ngIf="selectedInvoices.length > 0"
            [label]="'Process ' + selectedInvoices.length + ' Selected Invoice' + (selectedInvoices.length > 1 ? 's' : '')"
            icon="pi pi-play-circle"
            [loading]="isProcessingIndividualInvoices"
            [disabled]="isProcessingIndividualInvoices"
            (onClick)="processMonthlyInvoicesOneByOne()"
            severity="primary"
            [pTooltip]="'Process selected invoices one by one'"
            tooltipPosition="bottom">
        </p-button>
        <p-divider *ngIf="selectedInvoices.length > 0" layout="vertical"></p-divider>
        <div class="flex align-items-center gap-2">
            <label for="queueMonth" class="font-semibold">Queue for:</label>
            <select id="queueMonth" class="p-inputtext p-component" [ngModel]="queueMonth" (ngModelChange)="queueMonth = +$event">
                <option [value]="1">January</option>
                <option [value]="2">February</option>
                <option [value]="3">March</option>
                <option [value]="4">April</option>
                <option [value]="5">May</option>
                <option [value]="6">June</option>
                <option [value]="7">July</option>
                <option [value]="8">August</option>
                <option [value]="9">September</option>
                <option [value]="10">October</option>
                <option [value]="11">November</option>
                <option [value]="12">December</option>
            </select>
            <input type="number"
                   id="queueYear"
                   class="p-inputtext p-component"
                   [(ngModel)]="queueYear"
                   min="2000"
                   max="2100"
                   style="width: 80px;">
            <p-button
                *ngIf="showDebugControls"
                label="Queue Invoices"
                icon="pi pi-clock"
                [loading]="isQueueingInvoices"
                [disabled]="isQueueingInvoices"
                (onClick)="queueMonthlyInvoices()"
                severity="warning">
            </p-button>
            <p-button
                *ngIf="showDebugControls"
                label="Check Invoices Ready To Send"
                icon="pi pi-check-circle"
                [loading]="isValidatingInvoices"
                [disabled]="isValidatingInvoices"
                (onClick)="validateInvoicesReadyToSend()"
                severity="info">
            </p-button>
        </div>
        <p-divider layout="vertical"></p-divider>
        <div class="flex align-items-center gap-2">
            <div class="flex align-items-center gap-2" *ngIf="showDebugControls">
                <input type="checkbox"
                       id="dryRunMode"
                       class="p-checkbox"
                       [(ngModel)]="dryRunMode">
                <label for="dryRunMode" class="font-semibold">Dry Run</label>
                <p-button
                    label="Clear Last Billed"
                    icon="pi pi-trash"
                    size="small"
                    severity="danger"
                    [outlined]="true"
                    (onClick)="clearLastBilled()">
                </p-button>
            </div>
            <p-button
                [label]="dryRunMode ? 'Test Process All (Dry Run)' : 'Process All Monthly Invoices'"
                icon="pi pi-play"
                [loading]="isProcessingIndividualInvoices"
                [disabled]="monthlyInvoicesPendingCount === 0 || isProcessingIndividualInvoices"
                (onClick)="processMonthlyInvoices()"
                [severity]="dryRunMode ? 'info' : 'success'"
                [pTooltip]="'Process all eligible invoices one by one'"
                tooltipPosition="left">
            </p-button>
        </div>
    </div>
</div>
<!-- Progress Bar for Individual Invoice Processing -->
<div *ngIf="isProcessingIndividualInvoices" class="surface-100 border-round mb-3 p-3">
    <div class="flex flex-column gap-2">
        <div class="flex align-items-center justify-content-between">
            <span class="font-medium">Processing Invoices Individually...</span>
            <span class="text-color-secondary">{{ processedInvoicesCount }} / {{ totalInvoicesToProcess }}</span>
        </div>
        <p-progressBar
            [value]="(processedInvoicesCount / totalInvoicesToProcess) * 100"
            [showValue]="false">
        </p-progressBar>
    </div>
</div>

<div class="flex align-items-center gap-5">
    <p-messages key="monthly-invoice-result"></p-messages>
    <p-button
        *ngIf="invoiceProcessingResult.length && (invoiceProcessingResult.length == totalInvoicesToProcess)"
        label="View Details"
        severity="info"
        (click)="openDetailedLogsDialog()">
    </p-button>
    <p-dialog [(visible)]="displayDetailedLogsDialog" header="Monthly Invoice Process Logs" [modal]="true">
        <ng-template pTemplate="content">
            <p-messages [value]="invoiceProcessingResult"></p-messages>
        </ng-template>
    </p-dialog>
</div>

<!-- Missing ParkPro profiles Action Section -->
<div *ngIf="missingSureparkProfilesInPpro.length > 0" class="surface-100 border-round mb-3 p-3">
    <div class="flex align-items-center gap-2">
    <div class="flex align-items-center gap-2">
        <i class="pi pi-exclamation-triangle text-red-500 text-xl"></i>
        <span class="font-medium">{{ missingSureparkProfilesInPpro.length }} SUREPARK profile(s) are missing from ParkPro.</span>
    </div>
    <p-button
        label="Add Missing Profiles"
        icon="pi pi-user-plus"
        [outlined]="true"
        severity="warning"
        size="small"
        (click)="openAddMissingProfileDialog()"
        [loading]="isMonthlyProfilesSaving">
    </p-button>
    </div>
</div>
<div class="grid p-fluid">
    <div class="col-12">
        <div class="card">
            <!-- <p-toolbar>
                <div class="p-toolbar-group-left">
                    <h5 class="m-0">Monthly Invoices</h5>
                </div>
            </p-toolbar> -->
            <p-table #invoiceTable [value]="invoices" [(selection)]="selectedInvoices"
                [globalFilterFields]="['suite', 'account', 'tenant_name', 'amt', 'tenant_status', 'bill_status', 'bill_status_reason']"
                [resizableColumns]="true" responsiveLayout="scroll" [paginator]="true" [rows]="1000" [rowHover]="true"
                [totalRecords]="totalInvoices" [loading]="isInvoicelistLoading" [lazy]="true" (onLazyLoad)="getInvoices($event)"
                sortField="account" [sortOrder]="1" dataKey="uniqueId">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <div class="flex align-items-center gap-2">
                            <p-toggleButton
                                [(ngModel)]="showOnlyOkToSend"
                                [onLabel]="'Showing Only Invoices to Send'"
                                offLabel="Showing All Invoices"
                                (onChange)="applyOkToSendFilter()"
                                styleClass="p-button-sm">
                            </p-toggleButton>
                            <small *ngIf="showOnlyOkToSend && hiddenRowsCount > 0" class="text-color-secondary">
                                ({{hiddenRowsCount}} rows hidden)
                            </small>
                        </div>
                        <div class="col-3">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    [(ngModel)]="searchTerm"
                                    (input)="applySearchFilter()"
                                    placeholder="Search..." />
                            </span>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem;">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th style="width: 3rem;">Status</th>
                        <th pResizableColumn pSortableColumn="account">
                            Account
                            <p-sortIcon field="account"></p-sortIcon>
                        </th>
                        <th>Tenant</th>
                        <th pResizableColumn pSortableColumn="last_billed">
                            Last Billed
                            <p-sortIcon field="last_billed"></p-sortIcon>
                        </th>
                        <th>Amount</th>
                        <th pResizableColumn pSortableColumn="tenant_status">
                            Tenant Status
                            <p-sortIcon field="tenant_status"></p-sortIcon>
                        </th>
                        <th pResizableColumn pSortableColumn="bill_status">
                            Bill Status
                            <p-sortIcon field="bill_status"></p-sortIcon>
                        </th>
                        <th>Reason</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-invoice>
                    <tr>
                        <td [ngClass]="getRequiredTdClassForError(invoice)">
                            <p-tableCheckbox [value]="invoice"></p-tableCheckbox>
                        </td>
                        <td [ngClass]="getRequiredTdClassForError(invoice)">
                            <!-- Status indicator -->
                            <div *ngIf="getInvoiceProcessingStatus(invoice) as status" class="flex align-items-center justify-content-center">
                                <i *ngIf="status === 'pending'" class="pi pi-clock text-gray-500"></i>
                                <i *ngIf="status === 'processing'" class="pi pi-spin pi-spinner text-blue-500"></i>
                                <i *ngIf="status === 'completed'" class="pi pi-check-circle text-green-500"></i>
                                <i *ngIf="status === 'error'"
                                   class="pi pi-times-circle text-red-500"
                                   [pTooltip]="getInvoiceProcessingError(invoice)"
                                   tooltipPosition="right"></i>
                            </div>
                        </td>
                        <td class="mpi-text-truncate" [ngClass]="getRequiredTdClassForError(invoice)">{{ invoice.suite }}-{{ invoice.account }}</td>
                        <td class="mpi-text-truncate" [ngClass]="getRequiredTdClassForError(invoice)" style="text-wrap: auto;max-width: 200px;">
                            {{ invoice.tenant_name }}
                        </td>
                        <td class="mpi-text-truncate" [ngClass]="getRequiredTdClassForError(invoice)">{{ getLastBilledDisplay(invoice) }}</td>
                        <td class="mpi-text-truncate" [ngClass]="getRequiredTdClassForError(invoice)">{{ invoice.amt | currency }}</td>
                        <td [ngClass]="getRequiredTdClassForError(invoice)">
                          <!-- TODO this code is causing a maximum call stack size exceeded error in browser console-->
                            <p-button (onClick)="handleTenantStatusClick($event, invoice, op)" styleClass="text-left px-0 mx-0" [text]="true" [label]="getTenantStatusLabel(invoice.tenant_status)">
                            </p-button>

                        </td>
                        <td [ngClass]="getRequiredTdClassForError(invoice)">
                            <p-button
                                (onClick)="onBillStatusClick($event, invoice, invbillop)"
                                styleClass="text-left px-0 mx-0"
                                [text]="true"
                                [label]="getBillStatusLabel(invoice.bill_status)"
                                [severity]="getBillStatusSeverity(invoice.bill_status)">
                                <p-overlayPanel #invbillop appendTo="body" showCloseIcon="true">
                                  <div class="flex flex-column gap-2">
                                    <label for="hold-reason" class="label-required">Why is this profile being put on hold?</label>
                                    <input pInputText  id="hold-reason" #holdReason />
                                  </div>
                                  <span class="flex align-items-center gap-1 mt-2">
                                    <p-checkbox [binary]="true" inputId="deactivate_keycards" #deactiveKeycards></p-checkbox>
                                    <label for="deactivate_keycards">Deactivate Customer Keycards</label>
                                  </span>
                                  <div class="w-full text-right p-2" >
                                    <p-button label="Save" [disabled]="!holdReason.value" (onClick)="updateBillStatus(invoice.bill_status, invoice.suite, invoice.account, holdReason.value, deactiveKeycards.checked())"/>
                                  </div>
                                </p-overlayPanel>
                            </p-button>
                        </td>
                        <td [ngClass]="getRequiredTdClassForError(invoice)" style="text-wrap: auto;max-width: 200px;">{{ invoice.bill_status_reason }}</td>
                        <td [ngClass]="getRequiredTdClassForError(invoice)">

<!--                          <a  pButton [routerLink]="['/invoice/99999/'+invoice.suite+'/'+invoice.account]" icon="pi pi-arrow-right" iconPos="right"></a>-->

                          <a pButton [href]="'/portal/apps/monthlyinvoice/'+ locationId + '/'+invoice.suite+'/'+invoice.account" icon="pi pi-arrow-right" iconPos="right"></a>
                        </td>
                    </tr>
                    <tr *ngIf="invoice.issue_description">
                        <td colspan="10" class="pt-0">
                            <small class="ui-messages-error block ml-0">
                                {{ invoice.issue_description }}
                            </small>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="10" class="text-center"><b>No Data Found.</b></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
  </div>

<p-overlayPanel #op appendTo="body" showCloseIcon="true">
    <div class="flex flex-column gap-2">
        <label for="reason" class="label-required">
            Why is this tenant status changing?
        </label>
        <input pInputText id="reason" [(ngModel)]="reason" />
    </div>
    <div class="w-full text-right p-2">
        <p-button label="Save" [disabled]="!reason" (onClick)="updateTenantStatus(activeInvoice!.tenant_status, activeInvoice!.suite, activeInvoice!.account, reason)" />
    </div>
</p-overlayPanel>
<p-dialog [(visible)]="showAddMissingProfilesDialog" [modal]="true" [closable]="false" [draggable]="false"
    [resizable]="false" header="Add Missing SUREPARK Profile to ParkPro" [style]="{width: '90vw'}"
    [dismissableMask]="true">
    <p-stepper [linear]="true" [activeStep]="currentStepIndex">
        <p-stepperPanel header="Select Profile(s)">
            <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                <div class="mb-3 flex align-items-center justify-content-between">
                    <p class="text-gray-600 mb-3">
                        The following SUREPARK profiles are not found in ParkPro.
                        Select the profiles you want to add as ParkPro tenant.
                    </p>
                    <!-- <div class="flex gap-2 align-items-center">
                        <p-checkbox [(ngModel)]="hideEmptySureparkGroups" [binary]="true" inputId="hide-groups" (onChange)="filterMissingSureparkGroups()"/>
                        <label for="hide-groups">Hide Empty SUREPARK groups</label>
                    </div> -->
                </div>
                <p-table [value]="missingSureparkProfilesInPpro" [(selection)]="selectedSureparkProfiles" dataKey="id"
                    [tableStyle]="{'min-width': '50rem'}">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                            <th>Name</th>
                            <th># of members</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-group>
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="group" />
                            </td>
                            <td>{{ group.name }}</td>
                            <td>{{ group?.members?.length || 0 }} ({{ getGroupMembers(group, true)?.length || 0 }} Active)</td>
                        </tr>
                    </ng-template>
                </p-table>
            </ng-template>
        </p-stepperPanel>
        <p-stepperPanel header="Add Ppro Details">
            <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                <div class="mb-3">
                    <p class="text-gray-600 mb-3">
                        Add required details for tenant profile.
                    </p>
                </div>
                <p-table [value]="selectedSureparkProfiles" [tableStyle]="{'min-width': '50rem'}">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Name</th>
                        <th># of members</th>
                        <th>Suite</th>
                        <th>Account</th>
                        <th>Tenant Name</th>
                        <th>Biling Contact</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-group let-rowIndex="rowIndex">
                    <tr>
                        <td>{{ group.name }}</td>
                        <td>{{ group?.members?.length || 0 }} ({{ getGroupMembers(group, true)?.length || 0 }} Active)</td>
                        <td>
                            <div [formGroup]="getTenantProfileFormGroup(rowIndex)">
                                <input pInputText placeholder="Enter suite" id="suite" formControlName="suite" />
                                <div *ngIf="tenantProfileDetailsFormSubmitted && getTenantProfileControlError(rowIndex, 'suite')">
                                    <div class="ui-messages-error" *ngIf="getTenantProfileControlError(rowIndex, 'suite')?.['required']">Please
                                        enter suite.
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div [formGroup]="getTenantProfileFormGroup(rowIndex)">
                                <input pInputText id="account" formControlName="account" />
                            </div>
                        </td>
                        <td>
                            <div [formGroup]="getTenantProfileFormGroup(rowIndex)">
                                <input pInputText id="name" formControlName="name" />
                                <div *ngIf="tenantProfileDetailsFormSubmitted && getTenantProfileControlError(rowIndex, 'name')">
                                    <div class="ui-messages-error" *ngIf="getTenantProfileControlError(rowIndex, 'name')?.['required']">Please
                                        enter tenant name.
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            @if(hasBillingContactDetails(rowIndex)) {
                                <p-button label="Edit Billing Contact Details" (onClick)="displayAddBillingContactDialog(rowIndex)" />
                            } @else {
                                <p-button label="Add Billing Contact Details" (onClick)="displayAddBillingContactDialog(rowIndex)" />
                            }

                            <div *ngIf="tenantProfileDetailsFormSubmitted && !hasBillingContactDetails(rowIndex, true)">
                                <div class="ui-messages-error">Please enter valid billing contact details.
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            </ng-template>
        </p-stepperPanel>
        <p-stepperPanel header="Select Members">
            <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                <div class="mb-3">
                    <p class="text-gray-600 mb-3">
                        Select surepark group members to import into ParkPro
                    </p>
                    <p-table [value]="sureparkProfilesSubscribers" [(selection)]="selectedSureparkProfilesSubscribers" dataKey="id"
                        [tableStyle]="{'min-width': '50rem'}">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                                <th>Name</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th># of identifiers</th>
                                <th>Status</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-member>
                            <tr>
                                <td>
                                    <p-tableCheckbox [value]="member" />
                                </td>
                                <td>{{ member.firstName }} {{ member.lastName }}</td>
                                <td>{{ member.startValidity | date }}</td>
                                <td>{{ member.endValidity | date }}</td>
                                <td>{{ member.identifiers.length }}</td>
                                <td>
                                    <p-tag value="{{ member.active ? 'Active': 'Not Active' }}" [severity]="member.active ? 'success' : 'danger'" />
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </ng-template>
        </p-stepperPanel>
        <p-stepperPanel header="Confirmation">
            <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                <div class="col-12">
                    <p-messages key="contact-profile-complete" />
                    <div *ngIf="isMonthlyProfilesSaving">
                        <div class="col-12 md:col-8 lg:col-6 md:lg:col-offset-2 lg:col-offset-3">
                            <div class="flex justify-content-between flex-wrap">
                                <h1>Saving tenants</h1>
                            </div>

                            <p-progressBar [value]="tenantProfileSavedPercent">
                                <ng-template pTemplate="content" let-value>
                                    <span>{{value}}%</span>
                                </ng-template>
                            </p-progressBar>
                            <div class="flex justify-content-between flex-wrap">
                                <h3>{{ tenantProfilesData.length }} / {{ totalTenantProfileSaved }}</h3>
                                <h3 class="ui-messages-error my-auto">Failed {{ tenantProfileSaveFailed }}</h3>
                            </div>
                        </div>
                    </div>
                    <p-messages key="contact-profile-errors" />
                </div>
            </ng-template>
        </p-stepperPanel>
    </p-stepper>
    <ng-template pTemplate="footer">
        <div *ngIf="currentStepIndex === 0" class="grid">
            <div class="col-12 flex align-items-center justify-content-between">
                <p-button label="Cancel" (onClick)="closeMissingProfileDialog()" />
                <p-button label="Next" (onClick)="goToAddpproDetailsStep()" [disabled]="!selectedSureparkProfiles.length"/>
            </div>
        </div>
        <div *ngIf="currentStepIndex === 1" class="grid">
            <div class="col-12 flex align-items-center justify-content-between">
                <p-button label="Back" (onClick)="goToGroupSelectionStep()"/>
                <p-button label="Next" (onClick)="goToContactSelectionStep()"/>
            </div>
        </div>
        <div *ngIf="currentStepIndex === 2" class="grid">
            <div class="col-12 flex align-items-center justify-content-between">
                <p-button label="Back" (onClick)="goToAddpproDetailsStep()" />
                <p-button label="Create ParkPro Tenant(s)" (onClick)="processTenantAccounts()"/>
            </div>
        </div>
        <div *ngIf="currentStepIndex === 3">
            <p-button label="Close" (onClick)="closeMissingProfileDialog()" [loading]="isMonthlyProfilesSaving"/>
        </div>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="showAddBillingContactDialog" [style]="{ width: '450px' }" header="Billing Contact Details" [modal]="true"
    styleClass="p-fluid">
    <ng-template pTemplate="content">
        @if(selectedTenantProfileFormGroupIndex !== undefined) {
            <form [formGroup]="getTenantProfileFormGroup(selectedTenantProfileFormGroupIndex)">
                <div class="field col">
                    <h1>Billing Contact</h1>
                </div>

                <div class="field col">
                    <label for="billto" class="label-required">Bill To</label>
                    <input pInputText id="billto" formControlName="billto" class="w-full" />
                    <div *ngIf="saveBillingContactFormSubmitted && getTenantProfileControlError(selectedTenantProfileFormGroupIndex, 'billto')">
                        <div class="ui-messages-error" *ngIf="getTenantProfileControlError(selectedTenantProfileFormGroupIndex, 'billto')?.['required']">Please
                            enter bill to.
                        </div>
                    </div>
                </div>

                <div class="field col">
                    <label for="address" class="label-required">Billing Address 1</label>
                    <input pInputText id="address" formControlName="address1" class="w-full" />
                    <div *ngIf="saveBillingContactFormSubmitted && getTenantProfileControlError(selectedTenantProfileFormGroupIndex, 'address1')">
                        <div class="ui-messages-error" *ngIf="getTenantProfileControlError(selectedTenantProfileFormGroupIndex, 'address1')?.['required']">
                            Please enter billing address.
                        </div>
                    </div>
                </div>

                <div class="field col">
                    <label for="address2">Billing Address 2</label>
                    <input pInputText id="address2" formControlName="address2" class="w-full" />
                </div>

                <div class="field col">
                    <label for="city" class="label-required">City</label>
                    <input pInputText id="city" formControlName="city" class="w-full" />
                    <div *ngIf="saveBillingContactFormSubmitted && getTenantProfileControlError(selectedTenantProfileFormGroupIndex, 'city')">
                        <div class="ui-messages-error" *ngIf="getTenantProfileControlError(selectedTenantProfileFormGroupIndex, 'city')?.['required']">
                            Please enter city.
                        </div>
                    </div>
                </div>

                <div class="field col">
                    <label for="state" class=" w-full">State</label>
                    <p-dropdown formControlName="state" [options]="states" optionLabel="name" placeholder="Select a State" class="w-full"
                        styleClass="w-full" id="state" />
                </div>

                <div class="field col">
                    <label for="zip" class="label-required w-full">Zip</label>
                    <input pInputText id="zip" formControlName="zip" class="w-full" />
                    <div *ngIf="saveBillingContactFormSubmitted && getTenantProfileControlError(selectedTenantProfileFormGroupIndex, 'zip')">
                        <div class="ui-messages-error" *ngIf="getTenantProfileControlError(selectedTenantProfileFormGroupIndex, 'zip')?.['required']">
                            Please enter zip.
                        </div>
                    </div>
                </div>
            </form>
        }
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" [text]="true" (onClick)="hideBillingContactDialog()" />
        <p-button label="Save" icon="pi pi-check" [text]="true" (onClick)="saveBillingContactDetails()" />
    </ng-template>
</p-dialog>
</div> <!-- End of LPR active content wrapper -->
